import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.5268 9.354c.3567.4217.3041 1.0527-.1175 1.4094l-4.7633 3.7634c-.4216.3567-1.0526.3041-1.4094-.1175S8.9325 13.3567 9.3541 13l4.7633-3.7634c.4216-.3567 1.0526-.3041 1.4094.1175",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12.8451 18.2443c-.4174.3617-.4625.9933-.1008 1.4106s.9933.4625 1.4106.1008l7.5-6.5c.4174-.3617.4625-.9933.1008-1.4106l-6.5-7.5c-.3617-.4174-.9933-.4625-1.4106-.1008s-.4625.9933-.1008 1.4107l5.8451 6.7443zM11.1549 5.7557c.4174-.3617.4625-.9932.1008-1.4106-.3617-.4173-.9933-.4625-1.4106-.1007l-7.5 6.5c-.4174.3617-.4625.9932-.1008 1.4106l6.5 7.5c.3617.4173.9933.4624 1.4106.1007s.4625-.9932.1008-1.4106l-5.845-6.7443z",
        clipRule: "evenodd"
    }, "1")
], "AudienceRetargeted", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
